import { render } from "./index.vue?vue&type=template&id=ae6e2372&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=ae6e2372&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae6e2372"

export default script